export interface SubscribeRequest {
  email: string;
  turnstileToken: string;
}

export interface SubscribeResult {
  ok: boolean;
  reason?: string;
}

export interface SubscribePort {
  submit(req: SubscribeRequest): Promise<SubscribeResult>;
}

export const fetchSubscribe: SubscribePort = {
  async submit(req: SubscribeRequest): Promise<SubscribeResult> {
    try {
      const res = await fetch("/subscribe", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(req),
      });
      if (!res.ok) {
        return { ok: false, reason: `http-${res.status}` };
      }
      const body = (await res.json()) as SubscribeResult;
      return body;
    } catch (err) {
      const message = err instanceof Error ? err.message : String(err);
      return { ok: false, reason: `network-${message}` };
    }
  },
};
